"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinMaxIndicator = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var d3 = tslib_1.__importStar(require("d3"));
var utils_1 = require("../../utils");
var MinMaxIndicator = (function (_super) {
    tslib_1.__extends(MinMaxIndicator, _super);
    function MinMaxIndicator(props) {
        var _this = _super.call(this, props) || this;
        _this.createAttributes = _this.createAttributes.bind(_this);
        _this.Indicator = null;
        _this.IndicatorLine = null;
        _this.IndicatorText = null;
        return _this;
    }
    MinMaxIndicator.prototype.componentDidMount = function () {
        this.createAttributes();
    };
    MinMaxIndicator.prototype.componentDidUpdate = function () {
        this.createAttributes();
    };
    MinMaxIndicator.prototype.createAttributes = function () {
        var _a = this.props, width = _a.width, height = _a.height, value = _a.value;
        var lineExtensionPx = 15;
        d3.select(this.IndicatorLine)
            .attr('x2', width + lineExtensionPx)
            .attr('y1', height)
            .attr('y2', height);
        d3.select(this.Indicator)
            .attr('x', width + lineExtensionPx)
            .attr('y', height - 9);
        d3.select(this.IndicatorText)
            .attr('x', width + lineExtensionPx + 25)
            .attr('y', height + 1)
            .text(value);
    };
    MinMaxIndicator.prototype.render = function () {
        var _this = this;
        var clipPath = this.props.clipPath;
        return (react_1.default.createElement("g", { clipPath: clipPath },
            react_1.default.createElement("line", { ref: function (el) { return (_this.IndicatorLine = el); }, stroke: utils_1.theme.colors.NTDarkGrey[200], strokeLinecap: "round", strokeDasharray: "1, 5", strokeWidth: 1, x1: 0, className: "minMaxIndicator_line" }),
            react_1.default.createElement("rect", { ref: function (el) { return (_this.Indicator = el); }, fill: utils_1.theme.colors.NTDarkGrey[100], width: 50, height: 18, className: "minMaxIndicator_rect" }),
            react_1.default.createElement("text", { ref: function (el) { return (_this.IndicatorText = el); }, fontSize: "1.2rem", dominantBaseline: "middle", textAnchor: "middle", fontFamily: utils_1.theme.fonts.robotoMonoRegular, fill: utils_1.theme.colors.NTDarkGrey[900], style: { lineHeight: '1.8rem' }, className: "minMaxIndicator_text" })));
    };
    return MinMaxIndicator;
}(react_1.PureComponent));
exports.MinMaxIndicator = MinMaxIndicator;
